import React from "react";
import UnionLeftIcon from "../assets/UnionLeft.svg";
import UnionRightIcon from "../assets/UnionRight.svg";
import colorPeakerIcon from "../assets/color_peaker.svg";
import crossIcon from "../assets/cross.svg";
import logo from "../assets/logo.svg";

const ChatInterface: React.FC = () => {
	const [messages, setMessages] = React.useState([
		{
			sender: "UnRepeat assistance",
			message:
				"I analyzed your gmail thread now, Tell me what do you want to do?",
		},
		{
			sender: "User",
			message:
				"Leave that and log in into my sales force account and then add Ahmed Al-kheerow as a lead, search his name and info in google.",
		},

		{
			sender: "UnRepeat assistance",
			message:
				"Can you give me the email and password you want me to login into?",
		},
	]);

	const [message, setMessage] = React.useState("");

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (!message) return;
		setMessages([...messages, { sender: "User", message }]);
		setMessage("");
	};

	return (
		<div>
			{/* NAVBAR DESIGN START HERE */}
			<div>
				<div className="flex flex-row justify-between items-center w-full h-[57px] pb-[16px] border-b-2">
					<div>
						<img src={logo} alt="" />
					</div>

					<div className="cursor-pointer">
						<img src={crossIcon} alt="" />
					</div>
				</div>
			</div>
			{/* NAVBAR DESIGN END HERE */}

			{/* CHAT SECTION START HERE */}
			<div className="overscroll-scroll h-[400px] overflow-y-auto scrollbar-hide flex flex-col">
				{messages.map((item, index) => {
					const isRepeatedSender =
						index > 0 && messages[index - 1].sender === item.sender;

					return (
						<div
							key={index}
							className={`${!isRepeatedSender ? "mt-[25px]" : "mt-0"}`} // Adjust margin dynamically
						>
							{item.sender === "UnRepeat assistance" ? (
								<div className="w-[420px] h-auto mt-[6px]">
									<p className="font-mont text-[#8A898E] text-[12px] sm:text-[14px] font-medium ml-[34px]">
										UnRepeat assistance
									</p>
									<div className="relative drop-shadow-md w-[280px] sm:w-[420px] h-auto ">
										<div className="relative bg-white rounded-[30.2px] ml-2 z-20">
											<p className="font-mont text-black text-[12px] sm:text-sm px-[24.38px] py-[18px] w-full font-normal sm:font-medium">
												{item.message}
											</p>
										</div>
										<div className="absolute bottom-0 left-0 z-10">
											<img src={UnionLeftIcon} alt="" />
										</div>
									</div>
								</div>
							) : (
								<div className="relative sm:pb-0">
									<div className="w-[420px] h-auto  sm:ml-auto ml-10">
										<div className="relative drop-shadow-md w-[280px] sm:w-[420px] h-auto mt-[6px]">
											<div className="relative bg-sender rounded-[30.2px] mr-3 z-20">
												<p className="font-mont text-sm px-[24.38px] py-[18px] w-full font-medium text-white">
													{item.message}
												</p>
											</div>
											<div className="absolute bottom-0 right-[2px] z-10">
												<img
													src={UnionRightIcon}
													alt=""
													className="w-[35px]"
												/>
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
					);
				})}
			</div>
			{/* CHAT SECTION END HERE */}

			{/* TEXT BOX SECTION START HERE */}
			<div className="flex justify-center mt-[32px]">
				<div
					className="p-[1px] w-[424px] rounded-[16px] cursor-pointer"
					style={{
						background:
							"linear-gradient(to bottom right, #00E5FF, #FF007E)",
					}}
				>
					<form
						onSubmit={onSubmit}
						className="flex items-center bg-white rounded-[16px] shadow-custom-blue-purple py-[12px] px-[17px]"
					>
						<div className="pr-[20px] border-r-2 border-gray-200">
							<img src={colorPeakerIcon} alt="" />
						</div>

						<div className="pl-[20px] flex-grow">
							<input
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								type="text"
								placeholder="Enter a task"
								className="font-mont text-[17px] font-normal text-black bg-transparent focus:ring-0 focus:outline-none w-full placeholder-black"
							/>
						</div>

						<button
							type="submit"
							className="cursor-pointer border-sender bg-sender rounded-full flex items-center justify-center w-9 h-9  relative"
						>
							<span className="inset-[1px] blur-[0.5px] absolute rounded-full border-t border-white/70"></span>
							{paperPlane}
						</button>
					</form>
				</div>
			</div>
			{/* TEXT BOX SECTION END HERE */}

			{/* SUGGESTED SECTION START HERE */}
			<div className="mt-[32px]">
				<div>
					<h2 className="text-md sm:text-[18px] text-[#65657F] font-mont font-semibold">
						Suggested tasks
					</h2>
				</div>

				<div className="flex flex-col sm:flex-row gap-[12px] mt-[12px]">
					{suggestedTasks.map((item, index) => (
						<div
							onClick={() => setMessage(item.task)}
							key={index}
							className="cursor-pointer "
						>
							<span className="text-xs sm:text-base font-mont font-medium text-[#65657F] bg-[#F7F7F8] rounded-full  px-[12px] py-[8px] ">
								{item.task}
							</span>
						</div>
					))}
				</div>
			</div>
			{/* SUGGESTED SECTION END HERE */}
		</div>
	);
};

export default ChatInterface;

const suggestedTasks = [
	{
		id: 1,
		task: "Summarize the email",
	},
	{
		id: 2,
		task: "Schedule a call with sender",
	},
];
const paperPlane = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ zIndex: "1", position: "relative" }}
	>
		<path
			d="M15.6213 6.76805L7.69421 2.80451C2.36935 0.137454 0.18385 2.32296 2.85091 7.64781L3.65658 9.25919C3.88809 9.73148 3.88809 10.2779 3.65658 10.7501L2.85091 12.3522C0.18385 17.6771 2.36009 19.8626 7.69421 17.1955L15.6213 13.232C19.1774 11.454 19.1774 8.54612 15.6213 6.76805ZM12.6301 10.6946H7.62938C7.2497 10.6946 6.93484 10.3797 6.93484 10C6.93484 9.62035 7.2497 9.30549 7.62938 9.30549H12.6301C13.0098 9.30549 13.3247 9.62035 13.3247 10C13.3247 10.3797 13.0098 10.6946 12.6301 10.6946Z"
			fill="#F8F9FA"
		/>
	</svg>
);
